<template>
    <b-container>
<div
  class="fixed-center d-flex align-items-center justify-content-center"
  style="bottom: 0; overflow-y: auto"
>
        <b-card
        style="width: 30rem"
        footer-bg-variant="white"
        >
          <b-card-header
          ><p class="h4 text-center mb-4">Sign in</p></b-card-header>

            <b-alert show variant="danger" v-if="errorLogin">{{errorAlert}}</b-alert>
            <b-form @submit="onSubmit">
                <b-form-group
                    id="username"
                    label="Username:"
                    label-for="username">
                  <b-input-group>
      <b-input-group-prepend is-text>
        <font-awesome-icon :icon="['fa', 'user']"/>
      </b-input-group-prepend>
                    <b-form-input
                        id="username"
                        v-model="username"
                        type="text"
                        placeholder="Username"
                        required
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
                <b-form-group
                    id="password"
                    label="Password:"
                    label-for="password">
                  <b-input-group>
      <b-input-group-prepend is-text>
        <font-awesome-icon :icon="['fa', 'lock']"/>
      </b-input-group-prepend>
                    <b-form-input
                        id="password"
                        v-model="password"
                        type="password"
                        placeholder="Secret Password"
                        autocomplete
                        required
                    ></b-form-input>
                    </b-input-group>
                </b-form-group>
                <b-button
                    type="submit"
                    pill variant="success"
                    class="align-center mb-2"
                    :disabled="show"
                >
                <b-spinner small v-if="show"></b-spinner>
            {{submitText}}</b-button>
            </b-form>
          <b-card-footer
            align="center"
          >
          <a href="/privacy" class="card-link">Privacy Policy</a>
          </b-card-footer>
        </b-card>
</div>
    </b-container>
</template>
<script>
import { AuthApi } from "@/auth/authApi";
export default {
  name: 'Login',
  data () {
      return {
          username:null,
          password:null,
          errorAlert:null,
          errorLogin:false,
          show:false,
          items: [
            {
              text: 'Home',
              to: { name: 'home' }
            },
            {
              text: 'Login',
              active: true
            }
          ]
      }
  },
  computed: {
      submitText () {
          if(!this.show) {
              return "Log in";
          }
          return "Logging in...";
      }
  },
  mounted() {
  },
  methods: {
      async onSubmit (event) {
          event.preventDefault();
          const formLogin = {
              'username': this.username,
              'password': this.password
          };
          try{
            this.show = true;
            const { data } = await AuthApi.validateUser(formLogin);
            this.errorLogin = false;
            const payload = {
                'access_token': data.access_token,
                'expires_in': data.expires_in
            };
            this.updateStore(payload);
            await this.$store.dispatch('user/loadUser');
          }catch(error){
              //console.log(error);
              this.errorAlert = error.response.data.detail;
              this.errorLogin = true;
          }finally{
              this.show = false;
          }
      },
      updateStore (payload){
          this.$store.commit('user/userLoginChanged', payload);
      }
  }
}
</script>
